import SiteMessagesInstance from '../../components/site-messages'
import loadingSpinner from './components/loading-spinner'

export class StepAttemptToConnect {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "attempt_to_connect";
  title = "Connect to Temp Stick";

  template = `
  <div class="onboarding-step" data-for="attempt_to_connect">
          
    <p class="onboarding-guide-instruction text-center">Connecting to your Temp Stick, please wait...</p>
    
    <div class="onboarding-loading">
      <div class="onboarding-loading__animation">${loadingSpinner()}</div>
      <div class="onboarding-loading__text">
        Please Wait
      </div>
    </div>
    
  </div>
  `;

  onBack = () => {
    window.location.href = window.site.home + '/sensors';
  }

  onActivate = () => {

    // reset attempt account
    this.onboarding.attempt_count = 0;

    // this.onboarding.attemptToConnect();
    this.onboarding.hideBackButton();

    // start the heartbeat
    this.onboarding.Temp_Stick_Heartbeat();

    this.connectedTimeout = setTimeout(() => {

      if(this.onboarding.is_connected) {
        return;
      }

      if(this.onboarding.current_step !== 'attempt_to_connect') {
        return;
      }

      this.onboarding.Set_Connected(false);
      this.onboarding.attempt_count = 0;

      SiteMessagesInstance.addMessage(
        "error",
        "We couldn't connect to the Temp Stick, make sure it's in setup mode and check the app's WiFi permissions"
      );
      SiteMessagesInstance.displayMessages();

      this.onboarding.goToStep('start_app');

    }, 60000);

  }

  bindActions = () => {

  }

}
